"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileLocation = exports.UriLocation = exports.UriLocationRaw = exports.BlobLocation = exports.LocalPathLocation = exports.Region = exports.NoAssemblyRegion = exports.PropTypes = exports.ElementId = void 0;
const shortid_1 = __importDefault(require("shortid"));
const mobx_state_tree_1 = require("mobx-state-tree");
const prop_types_1 = __importDefault(require("prop-types"));
const mobx_react_1 = require("mobx-react");
exports.ElementId = mobx_state_tree_1.types.optional(mobx_state_tree_1.types.identifier, shortid_1.default.generate);
// PropTypes that are useful when working with instances of these in react components
exports.PropTypes = {
    Region: prop_types_1.default.shape({
        refName: prop_types_1.default.string.isRequired,
        start: prop_types_1.default.number.isRequired,
        end: prop_types_1.default.number.isRequired,
    }),
    ConfigSchema: mobx_react_1.PropTypes.objectOrObservableObject,
    Feature: prop_types_1.default.shape({
        get: prop_types_1.default.func.isRequired,
        id: prop_types_1.default.func.isRequired,
    }),
};
exports.NoAssemblyRegion = mobx_state_tree_1.types
    .model('NoAssemblyRegion', {
    refName: mobx_state_tree_1.types.string,
    start: mobx_state_tree_1.types.number,
    end: mobx_state_tree_1.types.number,
    reversed: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.boolean, false),
})
    .actions(self => ({
    setRefName(newRefName) {
        self.refName = newRefName;
    },
}));
exports.Region = mobx_state_tree_1.types.compose('Region', exports.NoAssemblyRegion, mobx_state_tree_1.types.model({
    assemblyName: mobx_state_tree_1.types.string,
}));
exports.LocalPathLocation = mobx_state_tree_1.types.model('LocalPathLocation', {
    locationType: mobx_state_tree_1.types.literal('LocalPathLocation'),
    localPath: mobx_state_tree_1.types.string,
});
// like how blobId is used to get a blob map
exports.BlobLocation = mobx_state_tree_1.types.model('BlobLocation', {
    locationType: mobx_state_tree_1.types.literal('BlobLocation'),
    name: mobx_state_tree_1.types.string,
    blobId: mobx_state_tree_1.types.string,
});
exports.UriLocationRaw = mobx_state_tree_1.types.model('UriLocation', {
    locationType: mobx_state_tree_1.types.literal('UriLocation'),
    uri: mobx_state_tree_1.types.string,
    baseUri: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
    internetAccountId: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
    // auths information (such as tokens) needed for using this resource.
    // if provided, these must be completely sufficient for using it
    internetAccountPreAuthorization: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.model('InternetAccountPreAuthorization', {
        internetAccountType: mobx_state_tree_1.types.string,
        authInfo: mobx_state_tree_1.types.frozen(),
    })),
});
exports.UriLocation = mobx_state_tree_1.types.snapshotProcessor(exports.UriLocationRaw, {
    postProcessor: snap => {
        // xref https://github.com/mobxjs/mobx-state-tree/issues/1524 for Omit
        const { baseUri, ...rest } = snap;
        if (!baseUri) {
            return rest;
        }
        return snap;
    },
});
exports.FileLocation = mobx_state_tree_1.types.snapshotProcessor(mobx_state_tree_1.types.union(exports.LocalPathLocation, exports.UriLocation, exports.BlobLocation), {
    // @ts-ignore
    preProcessor(snap) {
        if (!snap) {
            return undefined;
        }
        // @ts-ignore
        // xref https://github.com/mobxjs/mobx-state-tree/issues/1524 for Omit
        const { locationType, ...rest } = snap;
        if (!locationType) {
            // @ts-ignore
            const { uri, localPath, blob } = rest;
            let locationType = '';
            if (uri !== undefined) {
                locationType = 'UriLocation';
            }
            else if (localPath !== undefined) {
                locationType = 'LocalPathLocation';
            }
            else if (blob !== undefined) {
                locationType = 'BlobLocation';
            }
            return { ...rest, locationType };
        }
        return snap;
    },
});
